import React from 'react';

import './Team.manage.item.scss';
import ItemMenu from "../../forms/menu/MenuComponent";
import {useNavigate} from "react-router-dom";
import Checkbox from "../../forms/inputs/Checkboxk";
import {useTranslation} from "react-i18next";
import AuditTrail, {PAGES} from "../../services/interactions/audit.trail";


function TeamManageItem({currentUser, member, selectedMembers, hoverMember, onHover, onDelete, onChange}) {
    const {t} = useTranslation(['common','teams']);
    const navigate = useNavigate();

    const onDetail = () => {
        AuditTrail.sendLog(PAGES.TEAMS_MANAGE, {tag: 'button', event: 'onClick', action: 'click option member detail', member_id: member._id, member_type: member.type});
        if (member.type === 'User') {
            navigate(`/users/view/${member._id}`);
            return;
        }
        navigate(`/teams/detail/${member._id}`);
    }

    const isChecked = () => {
        return selectedMembers.find((t) => t._id === member._id);
    }

    const isHover = () => {
        return hoverMember && hoverMember._id === member._id;
    }

    const handleClick = () => {
        AuditTrail.sendLog(PAGES.TEAMS_MANAGE, {tag: 'row', event: 'onClick', action: 'click row member', member_id: member._id, member_type: member.type});
        onHover(member);
    }

    return (
        <div className={`__ItemBase ${isHover() ? 'selected' : ''}`} onClick={handleClick}>
            <div>
                {
                    currentUser.userRoles.userPatients.edit? <Checkbox bool={isChecked()} onChange={() => onChange(member)}/> : ''
                }
            </div>
            <div className="name">
                <h3 onClick={onDetail}>{member.name}</h3>
            </div>
            <p>{member.email}</p>
            <p>{member.type}</p>
            <div>
                <ItemMenu actionWillRedirect={false} fixed={true} label={'Member Options'}
                          event={PAGES.TEAMS_MANAGE} eventParams={{member_id: member._id, member_type: member.type}}>
                    <>
                        <div className="_option" onClick={onDetail}>
                            <p>{t('teams:member-details')}</p>
                        </div>
                        {
                            currentUser.userRoles.userPatients.edit?
                                <div className="_option" onClick={() => onDelete(member)}>
                                    <p>{t('teams:delete-member')}</p>
                                </div> : ''
                        }
                    </>
                </ItemMenu>
            </div>
        </div>
    );
}

export default TeamManageItem;
